import React from "react";
import Whats from "./Whats";
import { Fade } from "react-awesome-reveal";
import "../styles/Header.scss";
import logo from "../images/logoHF.png";

const Header = () => {
  return (
    <header className="ovit-header">
      <nav
        className="navbar navbar-expand-lg navBarCustom"
        data-bs-theme="dark"
      >
        <div className="container-fluid navInner">
          <a className="navbar-brand brandWrap" href="#inicio" aria-label="OVIT Soluciones Web">
            <img className="imgLogo" src={logo} alt="Logo Ovit Soluciones Web" />
            <div className="brandText">
              <span className="brandName">OVIT</span>
              <span className="brandSub">Soluciones Web</span>
            </div>
          </a>

          <button
            className="navbar-toggler navToggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse navCollapse" id="navbarSupportedContent">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0 navLinks">
              <li className="nav-item">
                <a className="nav-link" aria-current="page" href="#nosotrosH">
                  Nosotros
                </a>
              </li>

              <li className="nav-item">
                <a className="nav-link" href="#whyUs">
                  ¿Por qué elegirnos?
                </a>
              </li>

              <li className="nav-item">
                <a className="nav-link" href="#ovit-services">
                  Servicios
                </a>
              </li>

              <li className="nav-item">
                <a className="nav-link" href="#proceso">
                  Nuestro Proceso
                </a>
              </li>

              <li className="nav-item">
                <a className="nav-link" href="#faq">
                  FAQ's
                </a>
              </li>

              <li className="nav-item">
                <a className="nav-link" href="#foot">
                  Contacto
                </a>
              </li>
            </ul>

            <div className="navActions">
              <Fade cascade direction="left">
                <Whats
                  classStyle="btn btnContactanos"
                  message="Hola, quiero más información."
                  text="Contáctanos"
                  phoneNumber="5215588093678"
                />
              </Fade>
            </div>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;
